import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'givingStrategy';

export interface FormValues {
  givingStrategy: number | null;
}

export const validation = yup.object().shape({
  givingStrategy: yup
    .number()
    .nullable()
    .required('Please, select an option'),
});
